var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 27V30H10V27C10 26.45 10.45 26 11 26H29C29.55 26 30 26.45 30 27Z",
    fill: "#162930",
    stroke: "#162930",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M16 19H12V26H16V19Z",
    fill: "#162930"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20 19H16V26H20V19Z",
    fill: "#162930"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M24 19H20V26H24V19Z",
    fill: "#162930"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28 19H24V26H28V19Z",
    fill: "#162930"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30.75H9C8.59 30.75 8.25 30.41 8.25 30C8.25 29.59 8.59 29.25 9 29.25H31C31.41 29.25 31.75 29.59 31.75 30C31.75 30.41 31.41 30.75 31 30.75Z",
    fill: "#162930"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.37 13.7501L20.37 10.1501C20.17 10.0701 19.83 10.0701 19.63 10.1501L10.63 13.7501C10.28 13.8901 10 14.3001 10 14.6801V18.0001C10 18.5501 10.45 19.0001 11 19.0001H29C29.55 19.0001 30 18.5501 30 18.0001V14.6801C30 14.3001 29.72 13.8901 29.37 13.7501ZM20 16.5001C19.17 16.5001 18.5 15.8301 18.5 15.0001C18.5 14.1701 19.17 13.5001 20 13.5001C20.83 13.5001 21.5 14.1701 21.5 15.0001C21.5 15.8301 20.83 16.5001 20 16.5001Z",
    fill: "#162930"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/bank-icon.0e247ffe3d9ad342782223b1d42b624d.svg";
export { ForwardRef as ReactComponent };